import { render, staticRenderFns } from "./SvgPictoPro.vue?vue&type=template&id=22dd7c79&scoped=true"
import script from "./SvgPictoPro.vue?vue&type=script&lang=ts"
export * from "./SvgPictoPro.vue?vue&type=script&lang=ts"
import style0 from "./SvgPictoPro.vue?vue&type=style&index=0&id=22dd7c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd7c79",
  null
  
)

export default component.exports